const loadImageFromFile = (file: File): Promise<HTMLImageElement> =>
    new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file)
        const img = new Image()
        img.onload = () => {
            URL.revokeObjectURL(url)
            resolve(img)
        }
        img.onerror = () => {
            URL.revokeObjectURL(url)
            reject(new Error('Failed to load image'))
        }
        img.src = url
    })

export const rotateImageFile = async (file: File, angle: number): Promise<File> => {
    const img = await loadImageFromFile(file)
    const radians = (angle * Math.PI) / 180
    const isVertical = angle % 180 !== 0
    const canvas = document.createElement('canvas')
    canvas.width = isVertical ? img.height : img.width
    canvas.height = isVertical ? img.width : img.height

    const ctx = canvas.getContext('2d')
    if (!ctx) {
        throw new Error('Canvas context unavailable')
    }

    ctx.translate(canvas.width / 2, canvas.height / 2)
    ctx.rotate(radians)
    ctx.drawImage(img, -img.width / 2, -img.height / 2)

    const blob = await new Promise<Blob>((resolve, reject) => {
        canvas.toBlob(
            result => {
                if (result) {
                    resolve(result)
                } else {
                    reject(new Error('Failed to rotate image'))
                }
            },
            'image/jpeg',
            0.92,
        )
    })

    const fileName = file.name.replace(/\.\w+$/, '') || 'image'
    return new File([blob], `${fileName}.jpg`, { type: 'image/jpeg' })
}
